import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Notification {
    id: string;
    type: 'payment' | 'update' | 'spending' | 'bank' | 'other';
    title: string;
    subtitle: string;
    details?: string;
    amount?: string;
    timestamp: string;
    isRead: boolean;
    avatar?: string; // Initial or icon path
    icon?: string;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private isOpenSubject = new BehaviorSubject<boolean>(false);
    isOpen$ = this.isOpenSubject.asObservable();

    private notificationsSubject = new BehaviorSubject<Notification[]>([
        {
            id: '1',
            type: 'payment',
            title: 'Payment from Mykola L.',
            subtitle: 'Payment via UPI',
            amount: '+₹450.00',
            timestamp: '3h ago',
            isRead: false,
            avatar: 'M'
        },
        {
            id: '2',
            type: 'update',
            title: 'Update to Our Service Fees',
            subtitle: 'Hello, We would like to inform you about an upcomin...',
            timestamp: '3h ago',
            isRead: false,
            avatar: 'B'
        },
        {
            id: '3',
            type: 'spending',
            title: 'Spending Increased',
            subtitle: 'Insufficient balance in your account',
            amount: '+18%',
            timestamp: '3h ago',
            isRead: true,
            icon: 'assets/icons/img-card.svg'
        },
        {
            id: '4',
            type: 'bank',
            title: 'Bank Connected',
            subtitle: 'Axis Bank account linked successfully',
            timestamp: '3h ago',
            isRead: true,
            icon: 'assets/icons/img-bank.svg'
        },
        {
            id: '5',
            type: 'bank',
            title: 'Bank Connected',
            subtitle: 'Axis Bank account linked successfully',
            timestamp: '3h ago',
            isRead: true,
            icon: 'assets/icons/img-bank.svg'
        }, {
            id: '1',
            type: 'payment',
            title: 'Payment from Mykola L.',
            subtitle: 'Payment via UPI',
            amount: '+₹450.00',
            timestamp: '3h ago',
            isRead: false,
            avatar: 'M'
        },
        {
            id: '2',
            type: 'update',
            title: 'Update to Our Service Fees',
            subtitle: 'Hello, We would like to inform you about an upcomin...',
            timestamp: '3h ago',
            isRead: false,
            avatar: 'B'
        },
        {
            id: '3',
            type: 'spending',
            title: 'Spending Increased',
            subtitle: 'Insufficient balance in your account',
            amount: '+18%',
            timestamp: '3h ago',
            isRead: true,
            icon: 'assets/icons/img-card.svg'
        },
        {
            id: '4',
            type: 'bank',
            title: 'Bank Connected',
            subtitle: 'Axis Bank account linked successfully',
            timestamp: '3h ago',
            isRead: true,
            icon: 'assets/icons/img-bank.svg'
        },
        {
            id: '5',
            type: 'bank',
            title: 'Bank Connected',
            subtitle: 'Axis Bank account linked successfully',
            timestamp: '3h ago',
            isRead: true,
            icon: 'assets/icons/img-bank.svg'
        }
    ]);
    notifications$ = this.notificationsSubject.asObservable();

    toggle() {
        this.isOpenSubject.next(!this.isOpenSubject.value);
    }

    open() {
        this.isOpenSubject.next(true);
    }

    close() {
        this.isOpenSubject.next(false);
    }

    markAsRead(id: string) {
        const current = this.notificationsSubject.value;
        const updated = current.map(n => n.id === id ? { ...n, isRead: true } : n);
        this.notificationsSubject.next(updated);
    }
}
